'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const { hydrate } = require('@grpn/hydration');

function RedemptionModalAlert({ alertMessage }) {
  return h(
    '.redemption-modal-alert',
    h(
      `.redemption-modal-content`,
      h(
        Translate,
        { attrs: { class: 'redemption-modal-warning icon-alert' } },
        `js.modules.redemption.${alertMessage}`
      )
    )
  );
}

module.exports = hydrate('RedemptionModalAlert', RedemptionModalAlert);
